export const model = {
  global: {
    tabClassName: "mytab",
    tabSetEnableMaximize: false,
    tabSetClassNameTabStrip: "mytabstrip",
  },
  borders: [],
  layout: {
    type: "row",
    id: "#c4f61be1-a9fd-46a5-9104-cdf174667540",
    children: [
      {
        type: "row",
        id: "#8b2e7e90-4c80-4fcc-9082-72adeff92558",
        children: [
          {
            type: "tabset",
            id: "#5e2f26a5-e44b-42b2-9a68c-84d4ba15979b",
            weight: 5.300413263417301,
            enableMaximize: false,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62acd41b5881cc",
                name: "Header",
                component: "Header",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
          {
            type: "tabset",
            id: "#5e2f26a5-e44b-42b2-9a68-84d4ba15979b",
            weight: 5.579877035416972,
            enableMaximize: false,
            tabStripHeight: 6,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62ad41b5881cc",
                name: "Controls",
                component: "Controls",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
          {
            type: "row",
            id: "#36f71d45-c3c0-4ab9-b4c8-3697b7a74315",
            weight: 94.14254075139405,
            children: [
              {
                type: "tabset",
                id: "#0f595b02-3565-44e0-9bb6-19a2da23c80e",
                weight: 24.022744240123114,
                enableMaximize: false,
                tabStripHeight: 6,
                children: [
                  {
                    type: "tab",
                    id: "#059925d6-c72e-4c81-992d-e22e83e0e4b9",
                    name: "Stay aware of the vector outcome spectrum while using the histogram and the filters to identify certain vectors to study more closely.",
                    component: "CombinedChart",
                    enableClose: false,
                    enableFloat: false,
                  },
                ],
                active: true,
              },
              {
                type: "row",
                id: "#b06bed58-d3c7-4984-a00d-3f328fb7c821",
                weight: 5.686587956459656,
                children: [
                  {
                    type: "tabset",
                    id: "#f441a5f0-eeba-4ad8-9e23-ffb0ac0b16e9",
                    weight: 24.850296272907844,
                    children: [
                      {
                        type: "tab",
                        id: "#1369a7a7-2022-4ecc-acda-60a488eef3af",
                        name: "VecLevel",
                        component: "VecLevel",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#cdea2568-4d53-43fd-9117-80013b8eb34b",
                    weight: 25.07485186354608,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852a-62ad41b5881c",
                        name: "VecEvents",
                        component: "VecEvents",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#5e3f157a-995e-4e7d-acbe-f071daad5e22",
                    weight: 25.07485186354608,
                    children: [
                      {
                        type: "tab",
                        id: "#de41138d-56f4-4ca4-b6f1-4cd261e29fe4",
                        name: "VecDates",
                        component: "VecDates",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                ],
              },
              {
                type: "row",
                id: "#f6e73983-2367-47a8-aa38-776d8f15f3d0",
                weight: 23.533175316669524,
                children: [
                  {
                    type: "row",
                    id: "#6bf48471-c155-44bc-87cf-6129ce7b424c",
                    weight: 68.15384615384616,
                    children: [
                      {
                        type: "tabset",
                        id: "#dcf284b6-c713-4658-96b9-2e831038b155",
                        weight: 79.53846153846153,
                        enableMaximize: false,
                        tabStripHeight: 6,
                        children: [
                          {
                            type: "tab",
                            id: "#2ce15326-2913-49b6-9401-b1cddc095be4",
                            name: "",
                            component: "VectorSetStudy",
                            enableClose: false,
                            enableFloat: false,
                          },
                        ],
                      },
                      {
                        type: "tabset",
                        id: "#5a1bec57-274e-4cfd-b325-2ba73046ce2b",
                        weight: 20.46153846153846,
                        enableMaximize: false,
                        children: [
                          {
                            type: "tab",
                            id: "#ab772d76-913c-4956-8aef-272ee76dcf0a",
                            name: "VectorSet",
                            component: "VectorSet",
                            enableClose: false,
                            enableFloat: false,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    type: "row",
                    id: "#9f350a56-64f6-4801-bbd4-7f965c82fd9a",
                    weight: 31.846153846153847,
                    children: [
                      {
                        type: "tabset",
                        id: "#3e2dd187-a60a-47cd-a046-abc87b3a6158",
                        weight: 8.615384615384615,
                        enableMaximize: false,
                        tabStripHeight: 6,
                        children: [
                          {
                            type: "tab",
                            id: "#e980bfc6-b820-4694-99ca-ac09aef73ad3z",
                            name: "",
                            component: "TableControl",
                            enableClose: false,
                            enableFloat: false,
                          },
                        ],
                      },
                      {
                        type: "tabset",
                        id: "#1044fcf4-049a-497e-90de-e90d74929cdd",
                        weight: 91.38461538461539,
                        enableMaximize: false,
                        tabStripHeight: 6,
                        children: [
                          {
                            type: "tab",
                            id: "#e980bfc6-b820-4694-99ca-ac09aef73ad3",
                            name: "",
                            component: "TableView",
                            enableClose: false,
                            enableFloat: false,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
